import * as React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { mixpanelTrack } from '@/analytics/client/mixpanel';
import { Spinner, Button } from '@/components/ui';
import { useAppDataStore } from '@/stores/appDataStore';
import { LOCAL_STORAGE_KEY } from '@/utils/growsurf';

const SignupPage: NextPage = () => {
  const router = useRouter();
  const setEpixelReferrer = useAppDataStore(state => state.setEpixelReferrer);
  const growsurfReferralCode = (router?.query?.['grsf'] as string | undefined);

  if (growsurfReferralCode) {
    localStorage.setItem(LOCAL_STORAGE_KEY, growsurfReferralCode);
  }

  const epixelSponsor = (router?.query?.['ref'] as string | undefined);

  if (epixelSponsor) {
    setEpixelReferrer(epixelSponsor);
  }

  React.useEffect(() => {
    mixpanelTrack.pageViewed({
      path: '/signup'
    });
    router.push('/signup/questionnaire');
  }, [router]);
  return <>
      <NextSeo title='Sign Up' />
      <div className='max-w-md mx-auto mb-10 font-lato font-bold text-center text-2xl tracking-tighter'>
        <Spinner className='mx-auto mb-3 w-8 h-8 text-purple-3' />
        Redirecting you to Signup
      </div>

      <div className='max-w-lg mx-auto text-center'>
        <p>If you're not redirected immediately, please click the button below</p>
        <Button className='mt-4' onClick={() => router.push('/signup/questionnaire')} variant='primary'>
          Sign Up Now
        </Button>
      </div>
    </>;
};

export default SignupPage;